import { nextTick } from "vue"

let queue: Promise<void> = Promise.resolve()
let pending = 0
// Low-priority work waits until nothing else is queued: lookup rows nothing paints come after the rows a scroll would reach.
const low: (() => void)[] = []

function whenIdle(callback: () => void) {
  // A tab the browser does not paint gets no idle periods; the timeout keeps the queue moving there.
  return typeof requestIdleCallback === "function"
    ? requestIdleCallback(callback, { timeout: 1000 })
    : setTimeout(callback, 200)
}

function enqueue(mount: () => void, isCancelled: () => boolean) {
  pending++
  queue = queue.then(
    () =>
      new Promise<void>((resolve) => {
        const done = () => {
          pending--
          resolve()
          if (!pending && low.length) low.shift()!()
        }
        if (isCancelled()) return done()
        whenIdle(() => {
          try {
            if (!isCancelled()) mount()
          } catch (error) {
            console.error("[idle-mount] A mount failed; the queue continues", error)
          }
          nextTick(done)
        })
      })
  )
}

/**
 * Runs `mount` in a browser idle period, one caller at a time: each waits for its render to
 * flush before the next starts, so a column mounts its content group by group between frames
 * instead of while the user scrolls to it. Returns a function that cancels a pending mount.
 */
export function mountWhenIdle(mount: () => void, priority: "high" | "low" = "high"): () => void {
  let cancelled = false
  const isCancelled = () => cancelled
  if (priority === "low" && pending) low.push(() => enqueue(mount, isCancelled))
  else enqueue(mount, isCancelled)
  return () => {
    cancelled = true
  }
}
